module.exports = __webpack_public_path__ + "static/media/5-wood.b0a15780.png";